

import { createContext } from 'react';

const LayoutContext = createContext();

export default LayoutContext;